import React from "react";
import PageLayoutWithHeaderNav from "./PageLayoutWithHeaderNav";
import AnalysisView from "./AnalysisView";

const AnalysisPage = () => {
  return (
    <PageLayoutWithHeaderNav maxWidth="100%">
      <AnalysisView />
    </PageLayoutWithHeaderNav>
  );
};

export default AnalysisPage;
